var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrameHealthRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 95,
    viewBox: "0 0 70 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_2054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4225 4.31029V90.7055C69.4225 93.0896 67.4963 95.0158 65.1122 95.0158H4.31029C1.92621 95 0 93.0738 0 90.7055V4.31029C0 1.92621 1.92621 0 4.31029 0H65.128C67.4963 0 69.4225 1.92621 69.4225 4.31029Z",
    fill: "url(#paint0_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 7.94666V87.0533C65 89.2363 63.3075 91 61.2126 91H7.78735C5.69252 90.9855 4 89.2218 4 87.0533V7.94666C4 5.76371 5.69252 4 7.78735 4H61.2265C63.3075 4 65 5.76371 65 7.94666Z",
    fill: "url(#paint1_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8722 18.2516V22.183C26.8722 22.4672 26.6512 22.6882 26.367 22.6882H21.5515C21.2673 22.6882 21.0462 22.9093 21.0462 23.1935V28.009C21.0462 28.2932 20.8252 28.5142 20.541 28.5142H16.6096C16.3254 28.5142 16.1044 28.2932 16.1044 28.009V23.1935C16.1044 22.9093 15.8834 22.6882 15.5992 22.6882H10.7994C10.5152 22.6882 10.2942 22.4672 10.2942 22.183V18.2516C10.2942 17.9674 10.5152 17.7464 10.7994 17.7464H15.6149C15.8991 17.7464 16.1202 17.5253 16.1202 17.2412V12.4256C16.1202 12.1414 16.3412 11.9204 16.6254 11.9204H20.5568C20.841 11.9204 21.062 12.1414 21.062 12.4256V17.2412C21.062 17.5253 21.2831 17.7464 21.5673 17.7464H26.367C26.6512 17.7464 26.8722 17.9674 26.8722 18.2516Z",
    fill: "url(#paint2_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.5756 39.6768H10.8467C10.5309 39.6768 10.2783 39.4241 10.2783 39.1084V37.2927C10.2783 36.9769 10.5309 36.7243 10.8467 36.7243H58.5756C58.8914 36.7243 59.144 36.9769 59.144 37.2927V39.1084C59.1283 39.4241 58.8914 39.6768 58.5756 39.6768Z",
    fill: "url(#paint3_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5758 17.0517H34.8929C34.5771 17.0517 34.3245 16.7991 34.3245 16.4833V14.6834C34.3245 14.3676 34.5771 14.115 34.8929 14.115H58.5758C58.8915 14.115 59.1441 14.3676 59.1441 14.6834V16.4991C59.1284 16.7991 58.8915 17.0517 58.5758 17.0517Z",
    fill: "url(#paint4_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.5656 24.7249H34.8929C34.5771 24.7249 34.3245 24.4723 34.3245 24.1565V22.3409C34.3245 22.0251 34.5771 21.7725 34.8929 21.7725H51.5656C51.8814 21.7725 52.134 22.0251 52.134 22.3409V24.1565C52.1182 24.4723 51.8814 24.7249 51.5656 24.7249Z",
    fill: "url(#paint5_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.5756 48.2973H10.8467C10.5309 48.2973 10.2783 48.0447 10.2783 47.7289V45.9132C10.2783 45.5975 10.5309 45.3449 10.8467 45.3449H58.5756C58.8914 45.3449 59.144 45.5975 59.144 45.9132V47.7289C59.1283 48.0447 58.8914 48.2973 58.5756 48.2973Z",
    fill: "url(#paint6_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.5756 56.9179H10.8467C10.5309 56.9179 10.2783 56.6653 10.2783 56.3495V54.5338C10.2783 54.218 10.5309 53.9654 10.8467 53.9654H58.5756C58.8914 53.9654 59.144 54.218 59.144 54.5338V56.3653C59.1283 56.6653 58.8914 56.9179 58.5756 56.9179Z",
    fill: "url(#paint7_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.5756 65.5543H10.8467C10.5309 65.5543 10.2783 65.3016 10.2783 64.9859V63.1702C10.2783 62.8544 10.5309 62.6018 10.8467 62.6018H58.5756C58.8914 62.6018 59.144 62.8544 59.144 63.1702V64.9859C59.1283 65.3016 58.8914 65.5543 58.5756 65.5543Z",
    fill: "url(#paint8_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.5756 74.1749H10.8467C10.5309 74.1749 10.2783 73.9222 10.2783 73.6065V71.7908C10.2783 71.475 10.5309 71.2224 10.8467 71.2224H58.5756C58.8914 71.2224 59.144 71.475 59.144 71.7908V73.6065C59.1283 73.9222 58.8914 74.1749 58.5756 74.1749Z",
    fill: "url(#paint9_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.5756 82.7954H10.8467C10.5309 82.7954 10.2783 82.5428 10.2783 82.227V80.4113C10.2783 80.0956 10.5309 79.843 10.8467 79.843H58.5756C58.8914 79.843 59.144 80.0956 59.144 80.4113V82.227C59.1283 82.5428 58.8914 82.7954 58.5756 82.7954Z",
    fill: "url(#paint10_linear_306_2054)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.4225 4.31029V90.7055C69.4225 93.0896 67.4963 95.0158 65.1122 95.0158H4.31029C1.92621 95 0 93.0738 0 90.7055V89.2056C37.0874 73.8906 54.3601 15.1571 58.2599 0H65.1122C67.4963 0 69.4225 1.92621 69.4225 4.31029Z",
    fill: "#1A6FB5",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_2054",
    x1: 95,
    y1: 126,
    x2: -6,
    y2: -5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    stopColor: "#5BA7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_2054",
    x1: 8.6241,
    y1: 7.04564,
    x2: 57.9385,
    y2: 78.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3061,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_2054",
    x1: 10,
    y1: 9.50001,
    x2: 25,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368525,
    stopColor: "#80E4FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CDDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_306_2054",
    x1: 10.2905,
    y1: 38.2072,
    x2: 59.1354,
    y2: 38.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_306_2054",
    x1: 34.3249,
    y1: 15.5844,
    x2: 59.1356,
    y2: 15.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_306_2054",
    x1: 34.3249,
    y1: 23.2616,
    x2: 52.1257,
    y2: 23.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_306_2054",
    x1: 10.2905,
    y1: 46.8317,
    x2: 59.1354,
    y2: 46.8317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_306_2054",
    x1: 10.2905,
    y1: 55.4562,
    x2: 59.1354,
    y2: 55.4562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_306_2054",
    x1: 10.2905,
    y1: 64.0807,
    x2: 59.1354,
    y2: 64.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_306_2054",
    x1: 10.2905,
    y1: 72.7052,
    x2: 59.1354,
    y2: 72.7052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_306_2054",
    x1: 10.2905,
    y1: 81.3296,
    x2: 59.1354,
    y2: 81.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_2054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.4225,
    height: 95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameHealthRecords);
export default __webpack_public_path__ + "static/media/Frame-HealthRecords.fcd462276f0dd66a424f218e65d8f9c9.svg";
export { ForwardRef as ReactComponent };